import {
  IconAlertOctagon,
  IconAlertTriangle,
  IconCustomBoltPause,
  IconInfoSquareRounded,
} from '@rossum/ui/icons/tabler';
import { Badge, SvgIcon, Tooltip } from '@rossum/ui/material';
import HTMLMessage from '../../../../../components/DatapointMessage/HTMLMessage';
import {
  BLOCKERS_COLOR,
  type MessagesStatsWithBlockers,
} from '../../sidebar-infosections/automation-blockers/helpers';

type MessageIndicatorProps = {
  messagesStats: MessagesStatsWithBlockers | undefined;
};

const IconsMap = {
  error: IconAlertOctagon,
  warning: IconAlertTriangle,
  info: IconInfoSquareRounded,
  blocker: IconCustomBoltPause,
};

export const MessageIndicator = ({ messagesStats }: MessageIndicatorProps) => {
  if (!messagesStats) {
    return null;
  }

  const { count, highestSeverity, tooltipContent } = messagesStats;
  const Icon = IconsMap[highestSeverity];
  const color: 'error' | 'warning' | 'info' =
    highestSeverity === 'blocker' ? BLOCKERS_COLOR : highestSeverity;

  // oxlint-disable-next-line no-unsafe-return -- @rossum/ui Tooltip lacks types
  return (
    <Tooltip
      title={tooltipContent ? <HTMLMessage content={tooltipContent} /> : null}
      placement="right"
    >
      <span data-testid="message-indicator" style={{ display: 'inline-flex' }}>
        <Badge
          max={9}
          badgeContent={count}
          invisible={count === 1}
          // TODO: @ui change `default` variant in theme overrides
          color="secondary"
          slotProps={{
            badge: {
              style: {
                minWidth: 16,
                height: 16,
                padding: '0 4px',
              },
            },
          }}
        >
          {/* TODO: @sidebarV2 Make it same as SchemaFieldIcon */}
          <SvgIcon
            color={color}
            // TODO: @ui correct fontSize should be `medium` - fix when we set correct icon sizes from design system
            fontSize="medium"
          >
            <Icon />
          </SvgIcon>
        </Badge>
      </span>
    </Tooltip>
  );
};
